// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__h6jVw","disabled":"FileBtn_disabled__3R1wY","warn":"FileBtn_warn__37M6_","fade":"FileBtn_fade__1wBWT"};